<template>
  <div class="News">
    <div class="title htitle fs24">
      {{title}}
    </div>
    <div class="list">
      <div class="li" v-for="n in news">
        <s_news :news="n"></s_news>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SNews from '@/components/news/News.vue';
export default {
  name: 'News',
  components: {
    s_news: SNews
  },
   data () {
     return {
       news: []
     }
   },
   computed: {
     title() {
       return '大赛新闻'
     },
     /* news() {*/
     /* return this.$store.state.news.news;*/
     /* }*/
   },
   mounted() {
     this.$http.get('/api/news').then(res => {
       this.news = res.data
     })
   }
}
</script>

<style scoped>

@media (min-width: 320px) and (max-width: 480px) {
  .News{
    width: 100vw;
  }
 }
 
 .News{
   margin-top: 6.5625vw;
   margin-left: auto;
   margin-right: auto;
   width: 57.6vw;
   min-height: 56vh;
 }
 .li:last-child > div{
   border-bottom: none;
 }
</style>